import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';

import { QUERY_KEYS, SEARCH_KEYS } from '@src/constants';
import { authLoginUtils } from '@src/helpers/auth.helpers';
import { ISearchKeysValues } from '@src/interfaces/navigation.interfaces';

import { authService } from '../services';

interface IUseQueryReadSearchParams {
  enabled?: boolean;
}

export const useQueryReadSearchParams = ({
  enabled = true,
}: IUseQueryReadSearchParams = {}) => {
  const [searchParams] = useSearchParams();

  const searchParamsData = Object.values(SEARCH_KEYS).reduce(
    (acc, value) => {
      acc[value] = searchParams.get(value);
      return acc;
    },
    {} as Record<ISearchKeysValues, string | null>,
  );

  const { token } = searchParamsData;

  return useQuery({
    queryKey: [QUERY_KEYS.readSearchParams, { token }],
    queryFn: async () => {
      const response = await authService.loginByOtp({ token: token! }, true);

      if (response.data) {
        authLoginUtils(response.data);
      } else {
        throw response;
      }

      return searchParamsData;
    },
    enabled: enabled && !!token,
    retry: false,
  });
};
